module.exports = __webpack_public_path__ + "static/servicee-5aa67edcf55b30bcbcfe9e00a6f0cce9.svg";